import { HiOutlineChartBar } from 'react-icons/hi2';
import './empty-chart.scss';

const baseClassName = 'empty-chart';

export const EmptyChart = (): JSX.Element => {
  return (
    <div className={baseClassName}>
      <div className="icon">
        <HiOutlineChartBar />
      </div>
      <span>No data for the selected period</span>
    </div>
  );
}
